<template>
    <div class="main">
        <div class="main-title">
            <span class="main-back" @click="goBack"></span>
            <span>添加图片描述</span>
            <span class="complete-btn" @click="sortComplete">完成</span>
        </div>
        <h3 class="title-tips">点击拖拽改变图片顺序</h3>
        <div class="img-list">
            <draggable v-model="imgList" @start="dragStart" @end="dragEnd">
                <transition-group>
                    <div class="img-item" v-for="(img, index) in imgList">
                        <img :src="img.url">
                    </div>
                </transition-group>
            </draggable>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    export default {
        data() {
            return {
                imgList: [],
                formData: {},
            }
        },
        mounted(){
            if(this.$route.query.imgList[0].url){
                this.imgList = this.$route.query.imgList;
                // console.log(this.imgList);
            }else{
                this.goBack();
            }
            if(this.$route.query.formData){
                this.formData = this.$route.query.formData;
            }
        },
        components: {
            draggable,
        },
        computed: {

        },
        methods: {
            goBack (){
                this.$router.go(-1);
            },
            sortComplete (){
                this.$router.push({path: 'EditImgList', query:{imgList: this.imgList, formData: this.formData}})
            },
            dragStart (){
                // console.log(this.imgList);
            },
            dragEnd (){
                console.log(this.imgList);
            },
        }
    }
</script>
<style scoped>
    .main-title {
        position: relative;
        background: #fff;
        line-height: 0.9rem;
        font-size: 0.34rem;
        color: #333333;
        text-align: center;
        border-bottom: 1px solid #eee;
    }
    .main-back{
        float: left;
        display: inline-block;
        width: 0.5rem;
        height: 0.5rem;
        background: url('./../../assets/img/back-btn.png') no-repeat center center;
        background-size: 0.45rem 0.45rem;
        position: absolute;
        top:  0.2rem;
        left: 0.1rem;
    }
    .complete-btn{
        float: right;
        display: inline-block;
        margin-right: 0.25rem;
    }
    .title-tips{
        font-size: 0.32rem;
        padding-left: 0.25rem;
        padding-top: 0.2rem;
    }
    .img-list{
        padding: 0.2rem;
        overflow: hidden;
    }
    .img-item{
        width: 33.3%;
        height: 1.6rem;
        margin-bottom: 0.1rem;
        padding: 0.1rem 1.2% 0 1.2%;
        float: left;
    }
    .img-item:nth-child(3n){
        margin-right: 0;
    }
    .img-item img{
        width: 100%;
        height: 100%;
    }
</style>




// WEBPACK FOOTER //
// src/components/pageatlas/ImgListSort.vue